import type { FC, ReactNode } from 'react'
import { useState } from 'react'
import { PatientUser } from '~/shared/types'
import { Box } from '@mui/material'
import { Popover, Tabs, Tab } from '@mui/material'
import {
  PatientDetailPopOverTabValueTypes,
  patientDetailsActiveTabsType,
} from './PatientDetailTopBar'
import { required } from '~/shared/lib/required'

interface PatientDetailPopoverProps {
  patient: PatientUser
  anchorEl: Element
  onClose: () => void
  activeTabs: patientDetailsActiveTabsType[]
}

interface TabPanelProps {
  children: ReactNode
  value: PatientDetailPopOverTabValueTypes
  selectedTab: PatientDetailPopOverTabValueTypes
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, selectedTab } = props
  const visible = value === selectedTab

  return (
    <div
      role="tabpanel"
      hidden={!visible}
      id={`appointment-tabpanel-${value}`}
      aria-labelledby={`appointment-tab-${value}`}
    >
      {visible && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  )
}

const PatientDetailPopover: FC<PatientDetailPopoverProps> = props => {
  const [selectedTab, setSelectedTab] = useState<PatientDetailPopOverTabValueTypes>(
    required(props.activeTabs[0], 'an active tab').value,
  )

  const handleChange = (
    event: React.SyntheticEvent,
    newValue: PatientDetailPopOverTabValueTypes,
  ) => {
    setSelectedTab(newValue)
  }

  return (
    <Popover
      open={!!props.anchorEl}
      anchorEl={props.anchorEl}
      onClose={props.onClose}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{ paper: { sx: { maxWidth: 450 } } }}
    >
      <Tabs
        textColor="primary"
        indicatorColor="primary"
        value={selectedTab}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          minWidth: 80,
          minHeight: 0,
        }}
      >
        {props.activeTabs.map((v, i) => (
          <Tab
            label={v.label}
            value={v.value}
            key={i}
            sx={{
              minWidth: 80,
              minHeight: 0,
            }}
          />
        ))}
      </Tabs>
      {props.activeTabs.map((tabs, i) => (
        <TabPanel value={tabs.value} selectedTab={selectedTab} key={i}>
          <tabs.component patient={props.patient} />
        </TabPanel>
      ))}
    </Popover>
  )
}

export default PatientDetailPopover
